import * as ambassadorWixContactsV4SubmitContact from './contacts-v4-submit-contact-submitted-contact.http.js';
import * as ambassadorWixContactsV4SubmitContactTypes from './contacts-v4-submit-contact-submitted-contact.types.js';
import * as ambassadorWixContactsV4SubmitContactUniversalTypes from './contacts-v4-submit-contact-submitted-contact.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function appendOrCreateContact(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixContactsV4SubmitContactUniversalTypes.SubmitContactRequest,
  ambassadorWixContactsV4SubmitContactTypes.SubmitContactRequest,
  ambassadorWixContactsV4SubmitContactUniversalTypes.SubmitContactResponse,
  ambassadorWixContactsV4SubmitContactTypes.SubmitContactResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixContactsV4SubmitContact.submitContact(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v4/contact-submit',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export {
  SubmitContact as SubmitContactOriginal,
  SubmitContactRequest as SubmitContactRequestOriginal,
  ContactInfo as ContactInfoOriginal,
  ContactName as ContactNameOriginal,
  ContactEmailsWrapper as ContactEmailsWrapperOriginal,
  ContactEmail as ContactEmailOriginal,
  EmailTag as EmailTagOriginal,
  EmailTagWithLiterals as EmailTagWithLiteralsOriginal,
  ContactPhonesWrapper as ContactPhonesWrapperOriginal,
  ContactPhone as ContactPhoneOriginal,
  PhoneTag as PhoneTagOriginal,
  PhoneTagWithLiterals as PhoneTagWithLiteralsOriginal,
  ContactAddressesWrapper as ContactAddressesWrapperOriginal,
  ContactAddress as ContactAddressOriginal,
  AddressTag as AddressTagOriginal,
  AddressTagWithLiterals as AddressTagWithLiteralsOriginal,
  Address as AddressOriginal,
  AddressStreetOneOf as AddressStreetOneOfOriginal,
  StreetAddress as StreetAddressOriginal,
  AddressLocation as AddressLocationOriginal,
  Subdivision as SubdivisionOriginal,
  SubdivisionType as SubdivisionTypeOriginal,
  SubdivisionTypeWithLiterals as SubdivisionTypeWithLiteralsOriginal,
  AssigneesWrapper as AssigneesWrapperOriginal,
  LabelsWrapper as LabelsWrapperOriginal,
  ExtendedFieldsWrapper as ExtendedFieldsWrapperOriginal,
  LocationsWrapper as LocationsWrapperOriginal,
  ContactPicture as ContactPictureOriginal,
  Image as ImageOriginal,
  ImageProvider as ImageProviderOriginal,
  ImageProviderWithLiterals as ImageProviderWithLiteralsOriginal,
  ContactActivity as ContactActivityOriginal,
  ContactActivityType as ContactActivityTypeOriginal,
  ContactActivityTypeWithLiterals as ContactActivityTypeWithLiteralsOriginal,
  ActivityIcon as ActivityIconOriginal,
  SubmitContactOptions as SubmitContactOptionsOriginal,
  SubmitContactResponse as SubmitContactResponseOriginal,
  IdentityType as IdentityTypeOriginal,
  IdentityTypeWithLiterals as IdentityTypeWithLiteralsOriginal,
  ContactToSubmit as ContactToSubmitOriginal,
  SubmitOperation as SubmitOperationOriginal,
  SubmitOperationWithLiterals as SubmitOperationWithLiteralsOriginal,
  ContactSourceType as ContactSourceTypeOriginal,
  ContactSourceTypeWithLiterals as ContactSourceTypeWithLiteralsOriginal,
  SubmitVisitorIdRequest as SubmitVisitorIdRequestOriginal,
  SubmitVisitorIdResponse as SubmitVisitorIdResponseOriginal,
  MessageEnvelope as MessageEnvelopeOriginal,
  IdentificationData as IdentificationDataOriginal,
  IdentificationDataIdOneOf as IdentificationDataIdOneOfOriginal,
  WebhookIdentityType as WebhookIdentityTypeOriginal,
  WebhookIdentityTypeWithLiterals as WebhookIdentityTypeWithLiteralsOriginal,
  AccountInfo as AccountInfoOriginal,
  SubmitContactApplicationErrors as SubmitContactApplicationErrorsOriginal,
} from './contacts-v4-submit-contact-submitted-contact.types.js';
